import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";
import {
  INVITE_EMAIL_PLACEHOLDERS,
  INVITE_EMAIL_SLASH_ITEMS,
} from "@/lib/inviteEmailSnippets";

/** Összes / menü elem: sablon blokkok + placeholderek. */
export function buildInviteEmailSlashItems() {
  const blocks = INVITE_EMAIL_SLASH_ITEMS.map((item) => ({
    ...item,
    group: "Sablon",
  }));
  const placeholders = INVITE_EMAIL_PLACEHOLDERS.map((p) => ({
    id: `ph-${p.id}`,
    title: p.token,
    description: p.label,
    keywords: `${p.id} placeholder ${p.label}`,
    html: p.token,
    group: "Placeholder",
  }));
  return [...blocks, ...placeholders];
}

function filterSlashItems(query) {
  const q = (query || "").trim().toLowerCase();
  const all = buildInviteEmailSlashItems();
  if (!q) return all.slice(0, 12);
  return all
    .filter((item) => {
      const hay = `${item.title} ${item.description || ""} ${item.keywords || ""} ${item.id}`.toLowerCase();
      return hay.includes(q);
    })
    .slice(0, 12);
}

export function InviteEmailSlashExtension(extraSuggestion = {}) {
  return Extension.create({
    name: "inviteEmailSlash",

    addOptions() {
      return {
        suggestion: {
          char: "/",
          allowSpaces: false,
          startOfLine: false,
          items: ({ query }) => filterSlashItems(query),
          command: ({ editor, range, props }) => {
            const html = props.html || "";
            editor.chain().focus().deleteRange(range).insertContent(html).run();
          },
          ...extraSuggestion,
        },
      };
    },

    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          ...this.options.suggestion,
        }),
      ];
    },
  });
}
